import React from 'react';
import AnnotationMarkersRenderer from './AnnotationMarkersRenderer';

const AnnotationMarkersPlayback = () => {
  return <AnnotationMarkersRenderer />;
};
export default AnnotationMarkersPlayback;
